import React__default, { Children } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/Checkbox.scss';

var _excluded = ["children", "name", "value", "onChange", "className", "CheckedComponent"];
var DefaultCheckedComponent = function DefaultCheckedComponent(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    height: "20",
    viewBox: "0 0 20 20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m12.8033009 3v10h-5.00000004",
    stroke: "currentColor",
    strokeWidth: "2",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 8.674621 -4.942388)"
  })));
};
var Checkbox = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    name = _ref2.name,
    value = _ref2.value,
    onChange = _ref2.onChange,
    className = _ref2.className,
    _ref2$CheckedComponen = _ref2.CheckedComponent,
    CheckedComponent = _ref2$CheckedComponen === void 0 ? DefaultCheckedComponent : _ref2$CheckedComponen,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var checked = typeof value === "boolean" ? value : value === "true";
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className)
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    ref: ref,
    className: styles.input,
    id: name,
    name: name,
    checked: checked,
    type: "checkbox",
    role: "checkbox",
    "aria-checked": checked,
    "aria-labelledby": name,
    onChange: onChange
  })), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: name,
    className: styles.label
  }, value && /*#__PURE__*/React__default.createElement("div", {
    className: styles.checked
  }, /*#__PURE__*/React__default.createElement(CheckedComponent, {
    className: styles.icon
  })), Children.count(children) > 0 && /*#__PURE__*/React__default.createElement("span", {
    className: styles.children
  }, children)));
});

export { Checkbox };
//# sourceMappingURL=index.js.map
